import { ref } from "vue";
import { environmentData } from "@/helper/environment";
import { useImportLocationStore } from "@/store/import/import_location_store";
import { useImportSearchIdsStore } from "@/store/import/import_id_store";
import { ImportAssetServices } from "@/service/import/import_asset_service";
import { dateFormatWithoutOffset, isValidString } from "@/utils/date_formatter";
import type { EquipmentDetails, EquipmentDetailInterface } from "@/interface/import/import_asset_interface";
import { storeToRefs } from "pinia";
import ShippingCompany from "@/utils/liner_codes";

export class ImportAssetRepository {
  async getImportAssetDetail(): Promise<EquipmentDetailInterface> {
    const service = new ImportAssetServices();
    const searchIdsStore = useImportSearchIdsStore();
    const { importSearchIds } = storeToRefs(searchIdsStore);
    const locationStore = useImportLocationStore();
    const terminalId = locationStore.getImportSelectedTerminal.id;
    const ids = importSearchIds.value.join(",");
    const bookingNumbers = ref<string[]>([]);

    const url = `${environmentData.domain}/tt-import-availability?assetIds=${ids}&terminal=${terminalId}`;
    const containers: EquipmentDetailInterface = await service.fetchImportAssetDetail(url);
    containers.validIds.forEach((item: EquipmentDetails, index: number): void => {
      const bk = item.billOfLadingNumber ?? "";
      if (bk != "" && bk != null && !bookingNumbers.value.includes(bk)) {
        bookingNumbers.value.push(bk);
      }
      item.id = index;
      item.vesselOperator = ShippingCompany[item.vesselOperator] ?? item.vesselOperator;
      item.deliveryReady = item.isReadyForDelivery ? "YES" : "NO";
    });
    containers.bols = bookingNumbers.value;
    return containers;
  }

  async getExistingWatchListContainers(): Promise<EquipmentDetailInterface> {
    const service = new ImportAssetServices();
    const locationStore = useImportLocationStore();
    const terminalId = locationStore.getImportSelectedTerminal.id;

    const url = `${environmentData.domain}/v1/watchlist?terminal=${terminalId}`;
    const containers: EquipmentDetailInterface = await service.fetchExistingContainerDetails(url, "watchlistAPI");

    return containers;
  }

  getContainerDate = (date: string): string => {
    if (isValidString(date)) {
      return dateFormatWithoutOffset(date);
    }
    return "";
  };
}
